jQuery(document).ready(function($) {

    applyObjectPosition();

    $(window).resize(function () {
      applyObjectPosition();
    });

    const slider = $('.home-images');
    const header = $('header.header');

    slider.on('init', function () {
      updateHeaderGradient(slider.find('.slick-current img'));
    });

    $('.home-images').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: false,
        fade: true,
        cssEase: 'ease-in-out',
        pauseOnHover: false,
        speed: 600
    });

    function updateHeaderGradient(slideElement) {
      if ($('body').hasClass('drawer-open')) {
          return;
      }
  
      const gradientAlpha = parseFloat(slideElement.data('header-gradient')) / 100;
      header.css(
          'background',
          `linear-gradient(180deg, rgba(255, 255, 255, ${gradientAlpha}) 0%, rgba(255, 255, 255, 0) 100%) no-repeat padding-box`
      );
  }

    $('.home-images').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const nextSlideElement = $(slick.$slides[nextSlide]).find('img');
      updateHeaderGradient(nextSlideElement);
    });

    $('.contact-slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: false,
        fade: true,
        cssEase: 'ease-in-out',
        speed: 600
    });

    $('li.contact-trigger a').on('click', function(event) {
        event.preventDefault(); 
        $('body').addClass('drawer-open');
        $('header.header').css('background', '');
    });

    $('.logo-white').on('click', function(){
        $('body').removeClass('drawer-open');
        updateHeaderGradient(slider.find('.slick-current img'));
    });

   
    if (window.location.href.includes('#contact')) {
        setTimeout(function() {
            $('body').addClass('drawer-open');
        }, 2000); 
    }

  function applyObjectPosition() {
    if ($(window).width() < 800) {

      $('.home-images img').each(function () {
        var focX = $(this).data('foc-x') || 50; 
        var focY = $(this).data('foc-y') || 50;
        $(this).css({
          'object-position': focX + '% ' + focY + '%',
        });
      });
    } else {
      $('.home-images img').css({
        'object-position': '',
      });
    }
  }

});
